export default "__VITE_ASSET__vpNjbzaa__"